import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';

type BlockProps = {
  title: string;
  children: PropTypes.ReactElementLike;
};

const Block = ({ children, title }: BlockProps) => {
  return (
    <Paper sx={{ mt: 1, mb: 1, p: 2 }} variant="outlined">
      <Grid container>
        {title && (
          <>
            <Grid item xs={12}>
              <Typography variant="caption" align="left" sx={{ fontSize: 15 }}>
                {title}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(Block);
